import { Link, useNavigate } from 'react-router-dom';
import './auth.scss';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import clsx from 'clsx';
import { authenticationHttpService } from '@myinnsworth/httpServices';
import iconQuestionmark from '../../assets/images/icon-questionmark.svg';
import axios, { AxiosError } from 'axios';

const loginSchema = yup.object({
    email: yup.string().email('Invalid email address').required('Invalid email address'),
    password: yup.string().required('You must enter your password'),
    rememberMe: yup.boolean()
}).required();

interface ILoginSchema {
    email: string;
    password: string;
    rememberMe?: boolean;
}

export default function SignIn() {
    const navigate = useNavigate();
    const { register: registerInput, handleSubmit, clearErrors, setError, formState: { errors } } = useForm<ILoginSchema>({
        resolver: yupResolver(loginSchema)
    });

    const onSubmit = async (formData: ILoginSchema) => {
        clearErrors();
        try {
            await authenticationHttpService.signIn(formData.email, formData.password, !!formData.rememberMe)
            navigate('/dashboard');
        } catch(ex) {
            if(axios.isAxiosError(ex)) {
                const error = ex as AxiosError;
                switch(error.response!.status) {
                    case 400: { //400 - Account locked
                        setError('password', { message: 'Account locked for 5 minutes' });
                        break;
                    }
                    case 403: { //403 - Incorrect login details
                        setError('password', { message: 'Incorrect login details' });
                        break;
                    }
                }
            }
        }
    };

    return (
        <>
            <h6>Log in to My.Innsworth</h6>
            <div className="spacing-l"></div>

            <form className="auth-form-container" onSubmit={handleSubmit(onSubmit)} noValidate>
                <div className={clsx('form-control', 'normal', { 'error': errors.email })}>
                    <label >Email address</label>
                    <input {...registerInput('email')}
                        type="email"
                        className={clsx('icon-person', { 'error': errors.email })}
                        placeholder='Email Address' />
                    {errors.email && <p>{errors.email.message}</p>}
                    {!errors.email && <p>Please provide an email address</p>}
                </div>

                <div className="spacing-m"></div>

                <div className={clsx('form-control', 'normal', { 'error': errors.password })}>
                    <label>Password</label>
                    <input {...registerInput('password')}
                        type="password"
                        className={clsx('icon-lock', { 'error': errors.password })}
                        placeholder='Password' />
                    {errors.password && <p>{errors.password.message}</p>}
                    {!errors.password && <p>Please enter a password</p>}
                </div>

                <div className="spacing-m"></div>

                <div className="form-control normal checkbox ml-l">
                    {/* <input
                        {...registerInput('rememberMe')}
                        type="checkbox" />
                    <label> Remember me</label> */}

                    <label className="my-innsworth-checkbox">
                        <input
                            {...registerInput('rememberMe')}
                            type="checkbox" />
                        <span className="checkmark"></span>
                        Remember me
                    </label>
                </div>

                <div className="spacing-m"></div>

                <div className="flex direction-column ml-l forgot-password-container">
                    <Link className='link primary' to={"/auth/forgot-password"} >
                        Forgot password
                        <img className='ml-l' src={iconQuestionmark} alt="forgot password" />
                    </Link>
                </div>

                <div className="spacing-m"></div>

                <div className="flex justify-center">
                    <button type="submit" className="btn primary medium">Log in to my.innsworth</button>
                </div>

                <div className="spacing-m"></div>

                <div className="flex direction-column align-center">
                    <p className='light'>Don't have an account?</p>
                    <div className="spacing-xxs"></div>
                    <Link className='link secondary' to={"/auth/sign-up"} >Register for an account</Link>
                </div>

            </form>
        </>
    )
}